import { CircleUserRound, ListTodo, Package, ShoppingCart } from 'lucide-react';
import React, { type JSX, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';

interface NavItem {
  label: string;
  href: string;
  icon: JSX.Element;
}

const BottomNavigationBar: React.FC = () => {
  const [activeItem, setActiveItem] = useState<string | null>(null);
  const { t } = useTranslation();
  const location = useLocation();

  const navItems: NavItem[] = [
    {
      label: t('navigation.tasks'),
      href: '/tasks',
      icon: <ListTodo size={'2.25rem'} />,
    },
    {
      label: t('navigation.profile'),
      href: '/profile',
      icon: <CircleUserRound size={'2.25rem'} />,
    },
    {
      label: t('navigation.shop'),
      href: '/shop',
      icon: <ShoppingCart size={'2.25rem'} />,
    },
    {
      label: t('navigation.inventory'),
      href: '/inventory',
      icon: <Package size={'2.25rem'} />,
    },
  ];

  const handleTouchStart = (label: string) => {
    setActiveItem(label);
  };

  const handleTouchEnd = () => {
    setTimeout(() => setActiveItem(null), 150);
  };

  return (
    <Navbar fixed="bottom" bg="light" className="rounded-top-5 py-3">
      <Container fluid>
        <Nav className="w-100 justify-content-around">
          {navItems.map(item => {
            const isCurrent = location.pathname === item.href;
            const isActive = activeItem === item.label;

            return (
              <Nav.Item key={item.label} className="text-center">
                <Nav.Link
                  as={NavLink}
                  to={item.href}
                  className={`d-flex flex-column align-items-center transition-all ${
                    isActive ? 'animate-tap' : ''
                  }`}
                  onMouseDown={() => handleTouchStart(item.label)}
                  onMouseUp={handleTouchEnd}
                  onTouchStart={() => handleTouchStart(item.label)}
                  onTouchEnd={handleTouchEnd}
                  style={{
                    color: isCurrent ? 'var(--bs-primary)' : 'GrayText',
                    transition:
                      'transform 0.1s ease-in-out, opacity 0.1s ease-in-out',
                    transform: isActive ? 'scale(0.7)' : 'scale(1)',
                    opacity: isActive ? 0.7 : 1,
                  }}
                >
                  {item.icon}
                  <span
                    className="fw-bold mt-1"
                    style={{ fontSize: '0.75rem' }}
                  >
                    {item.label}
                  </span>
                </Nav.Link>
              </Nav.Item>
            );
          })}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default BottomNavigationBar;
